import { render, staticRenderFns } from "./ConfigCallSetUpTimeRangeDialog.vue?vue&type=template&id=63bc6345&scoped=true&"
import script from "./ConfigCallSetUpTimeRangeDialog.vue?vue&type=script&lang=js&"
export * from "./ConfigCallSetUpTimeRangeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc6345",
  null
  
)

export default component.exports